"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ParentSignature_1 = require("./ParentSignature");
exports.ParentSignature = ParentSignature_1.ParentSignature;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL1BhcmVudFNpZ25hdHVyZS9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHFEQUFpRDtBQUF6Qyw0Q0FBQSxlQUFlLENBQUEifQ==